import React, { useState, useEffect } from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const socialLinks = [
    {
      name: 'Instagram',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.004 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.875 1.297 2.026 1.297 3.323s-.49 2.448-1.297 3.323c-.875.807-2.026 1.297-3.323 1.297z"/>
        </svg>
      ),
      href: '#'
    },
    {
      name: 'LinkedIn',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      href: '#'
    },
    {
      name: 'Facebook',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      href: 'https://www.facebook.com/profile.php?id=100076362788898'
    },
    {
      name: 'Twitter',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      ),
      href: '#'
    }
  ];

  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'ATL Advertising', href: '#services' },
        { name: 'BTL Activations', href: '#services' },
        { name: '3D Billboards & Displays', href: '#services' },
        { name: 'PR Campaigns & Influencer Marketing', href: '#services' },
        { name: 'Digital Campaigns & Software Development', href: '#services' },
        { name: '2D & 3D Site Maps & Event Layout Rendering', href: '#services' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '#about' },
        { name: 'Our Team', href: '#about' },
        { name: 'Careers', href: '#careers' },
        { name: 'Portfolio', href: '#portfolio' },
        { name: 'Case Studies', href: '#portfolio' },
        { name: 'Testimonials', href: '#testimonials' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Blog', href: '#blog' },
        { name: 'News & Updates', href: '#news' },
        { name: 'Industry Insights', href: '#insights' },
        { name: 'Download Brochure', href: '#brochure' },
        { name: 'FAQ', href: '#faq' },
        { name: 'Support', href: '#support' }
      ]
    }
  ];

  return (
    <footer className="relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-primary via-brand-secondary to-brand-primary">
        {/* Floating Elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-brand-orange/10 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-brand-gold/15 rounded-full blur-lg animate-bounce"></div>
        <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-brand-orange/5 rounded-full blur-2xl animate-ping"></div>
        <div className="absolute bottom-32 right-1/3 w-12 h-12 bg-brand-gold/20 rounded-full blur-md animate-pulse"></div>
        
        {/* Grid Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="h-full w-full" style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.3) 1px, transparent 0)`,
            backgroundSize: '20px 20px'
          }}></div>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10">
        {/* Top Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            {/* Brand Section */}
            <div className="lg:col-span-4">
              <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                {/* Enhanced Logo */}
                <div className="flex items-center space-x-3 mb-6 group cursor-pointer">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-brand-orange/30 to-brand-gold/30 rounded-2xl blur-lg opacity-0 group-hover:opacity-100 transition-all duration-500 -z-10 scale-110"></div>
                    <div className="relative p-3 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 shadow-lg group-hover:shadow-xl group-hover:shadow-brand-orange/20 transition-all duration-500">
                      <img 
                        src="/assets/BA Logo-02 (1).png" 
                        alt="Brand Aviation" 
                        className="h-12 w-auto transition-all duration-500 group-hover:scale-110 group-hover:rotate-1"
                        onError={(e) => {
                          console.log('Footer logo failed to load, trying alternative');
                          e.currentTarget.src = '/assets/BA Logo-01 (1).png';
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white group-hover:text-brand-orange transition-all duration-300">
                      Brand Aviation
                    </h3>
                    <p className="text-brand-orange text-sm font-semibold">Elevating Brands, Igniting Impact</p>
                  </div>
                </div>

                <p className="text-gray-300 leading-relaxed mb-8 text-base lg:text-lg">
                  We create extraordinary experiences that make your brand soar higher. From billboard domination to immersive activations, we're your partners in aviation excellence.
                </p>

                {/* Newsletter Signup */}
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <h4 className="text-white font-semibold mb-3">Stay Updated</h4>
                  <p className="text-gray-300 text-sm mb-4">Get the latest aviation marketing insights delivered to your inbox.</p>
                  <div className="space-y-3">
                    <input 
                      type="email" 
                      placeholder="Enter your email"
                      className="w-full px-4 py-2.5 bg-white/20 border border-white/30 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-orange focus:border-transparent transition-all duration-300"
                    />
                    <button className="w-full px-6 py-2.5 bg-gradient-to-r from-brand-orange to-brand-gold text-white rounded-xl hover:shadow-lg hover:shadow-brand-orange/25 transition-all duration-300 font-semibold">
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Links Sections */}
            <div className="lg:col-span-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {footerSections.map((section, sectionIndex) => (
                  <div 
                    key={section.title}
                    className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                    style={{ transitionDelay: `${(sectionIndex + 1) * 200}ms` }}
                  >
                    <h4 className="text-white font-bold text-lg mb-6 relative">
                      {section.title}
                      <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-gradient-to-r from-brand-orange to-brand-gold rounded-full"></div>
                    </h4>
                    <ul className="space-y-3">
                      {section.links.map((link, linkIndex) => (
                        <li key={link.name}>
                          <a 
                            href={link.href}
                            className="group flex items-center text-gray-300 hover:text-brand-orange transition-all duration-300 text-sm lg:text-base"
                          >
                            <span className="w-0 h-0.5 bg-brand-orange transition-all duration-300 group-hover:w-4 mr-0 group-hover:mr-2"></span>
                            <span className="group-hover:translate-x-1 transition-transform duration-300">{link.name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Contact Info */}
              <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
                <h4 className="text-white font-bold text-xl mb-6">Get In Touch</h4>
                <div className="space-y-4">
                  <div className="flex items-center space-x-4 group">
                    <div className="p-3 bg-gradient-to-r from-brand-orange/20 to-brand-gold/20 rounded-xl group-hover:scale-110 transition-all duration-300">
                      <svg className="w-5 h-5 text-brand-orange" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-white font-semibold">Location</p>
                      <p className="text-gray-300">Blue Area, Islamabad, Pakistan</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4 group">
                    <div className="p-3 bg-gradient-to-r from-brand-orange/20 to-brand-gold/20 rounded-xl group-hover:scale-110 transition-all duration-300">
                      <svg className="w-5 h-5 text-brand-orange" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-white font-semibold">Email</p>
                      <p className="text-gray-300">info@brandaviation.com</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4 group">
                    <div className="p-3 bg-gradient-to-r from-brand-orange/20 to-brand-gold/20 rounded-xl group-hover:scale-110 transition-all duration-300">
                      <svg className="w-5 h-5 text-brand-orange" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-white font-semibold">Phone</p>
                      <p className="text-gray-300">0314-5154682</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Social Links */}
              <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                <h4 className="text-white font-bold text-xl mb-6">Follow Us</h4>
                <div className="flex flex-wrap gap-4">
                  {socialLinks.map((social, index) => (
                    <a
                      key={social.name}
                      href={social.href}
                      className="group relative p-4 bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 hover:border-brand-orange/50 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-brand-orange/25"
                      style={{ animationDelay: `${index * 100}ms` }}
                    >
                      <div className="text-gray-300 group-hover:text-brand-orange transition-colors duration-300">
                        {social.icon}
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-r from-brand-orange/10 to-brand-gold/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/10 bg-black/20 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
              <div className="text-gray-300 text-sm lg:text-base text-center lg:text-left">
                © {currentYear} Brand Aviation Pvt. Ltd. All rights reserved.
              </div>
              
              <div className="flex items-center space-x-6 text-sm">
                <a href="#privacy" className="text-gray-300 hover:text-brand-orange transition-colors duration-300">
                  Privacy Policy
                </a>
                <a href="#terms" className="text-gray-300 hover:text-brand-orange transition-colors duration-300">
                  Terms of Service
                </a>
                <a href="#cookies" className="text-gray-300 hover:text-brand-orange transition-colors duration-300">
                  Cookie Policy
                </a>
              </div>
            </div>
            
            {/* Developer Credit */}
            <div className="mt-4 pt-4 border-t border-white/10">
              <p className="text-center text-gray-400 text-sm">
                Developed and designed by{' '}
                <a 
                  href="https://beacontechh.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-brand-orange hover:text-brand-gold transition-colors duration-300 font-semibold"
                >
                  Beacontechh
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
